import { useState } from "react";
import { useLocation } from "react-router-dom";

import messages from "constants/messages";

import { completePasswordReset } from "../lib/auth-api";
import { getPasswordResetKey } from "../lib/auth-routes";

const { REQUEST_RESET_PASSWORD_ERROR } = messages;

export const useCompletePasswordReset = () => {
  const location = useLocation();

  const [alertType, setAlertType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async values => {
    setLoading(true);
    setMessage("");

    try {
      const response = await completePasswordReset({
        newPassword: values.newPassword,
        passwordResetKey: getPasswordResetKey(location.search)
      });

      if (response.data.Response === "Success") {
        setAlertType("success");
        setMessage(response.data.Message);
        return;
      }

      setAlertType("error");
      setMessage(response.data.ErrorMessage);
    } catch (error) {
      setAlertType("error");
      setMessage(REQUEST_RESET_PASSWORD_ERROR);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    alertType,
    handleSubmit,
    loading,
    message
  };
};